import { doc, getDoc, where } from "firebase/firestore";
import { db } from "../../../firebase";

const GetSingleSport = async (SportID) => {
  try {
    const SportDocument = doc(db, "Sports", SportID);
    const SportSnapshot = await getDoc(
      SportDocument,
      where("IsDeleted", "==", false)
    );

    let Sport = { ...SportSnapshot.data(), id: SportSnapshot.id };

    return Sport;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleSport;
